
import { Consultancy, Region, TherapeuticArea, ServiceType, RegulatoryPathway, ProductType, CompanySize, RFQ, Proposal, VerificationRequest, ClientFeedback, Subscription, Invoice, AddOn, Notification, Thread, Task, ReportedIssue, ContentItem, User, ActivityLog, OrgSettings } from './types';

export const MOCK_CONSULTANCIES: Consultancy[] = [
  {
    id: '1',
    name: 'BioReg Global Strategies',
    tagline: 'Specialized FDA & EMA Strategy for Gene Therapies',
    description: 'BioReg Global Strategies focuses exclusively on advanced therapy medicinal products (ATMPs). Our team consists of former FDA CBER reviewers and EMA CAT members, ensuring your gene therapy navigates the complex regulatory landscape with precision.',
    logoUrl: 'https://picsum.photos/id/101/200/200',
    regions: [Region.USA, Region.EU, Region.UK],
    therapeuticAreas: [TherapeuticArea.GENE_THERAPY, TherapeuticArea.RARE_DISEASE, TherapeuticArea.ONCOLOGY],
    services: [ServiceType.STRATEGY, ServiceType.SUBMISSIONS, ServiceType.AD_COM],
    pathways: [RegulatoryPathway.BLA, RegulatoryPathway.ORPHAN, RegulatoryPathway.RMAT, RegulatoryPathway.PRIME],
    productTypes: [ProductType.CELL_GENE, ProductType.BIOLOGIC],
    companySize: CompanySize.MID,
    badges: ['Former FDA Reviewers', 'Orphan Drug Specialist', 'Verified Partner'],
    verifiedApprovals: 12,
    orphanDesignations: 8,
    hourlyRateStart: 350,
    hourlyRateEnd: 550,
    teamSize: 65,
    foundedYear: 2012,
    isSponsored: true,
    responseTime: '< 24 hours',
    availability: 'Immediate',
    teamMembers: [
        { id: 'tm1', name: 'Dr. Jane Doe', role: 'Principal Consultant', credentials: ['PhD', 'RAC', 'Ex-FDA'] },
        { id: 'tm2', name: 'John Smith', role: 'Senior Strategist', credentials: ['MSc', 'Ex-EMA'] }
    ],
    technologies: ['Veeva Vault', 'Lorenz docuBridge'],
    languages: ['English', 'German', 'French'],
    status: 'approved'
  },
  {
    id: '2',
    name: 'PharmaLink Solutions',
    tagline: 'Full-Service CMC & Clinical Regulatory Support',
    description: 'A mid-sized consultancy providing end-to-end regulatory support for small molecules and biologics. We excel in eCTD publishing and life-cycle management across 50+ countries.',
    logoUrl: 'https://picsum.photos/id/102/200/200',
    regions: [Region.USA, Region.EU, Region.JAPAN, Region.CANADA, Region.BRAZIL, Region.CHINA],
    therapeuticAreas: [TherapeuticArea.CARDIOVASCULAR, TherapeuticArea.INFECTIOUS_DISEASE, TherapeuticArea.IMMUNOLOGY],
    services: [ServiceType.SUBMISSIONS, ServiceType.PUBLISHING, ServiceType.MEDICAL_WRITING],
    pathways: [RegulatoryPathway.STD_505_B_1, RegulatoryPathway.STD_505_B_2, RegulatoryPathway.ANDA],
    productTypes: [ProductType.SMALL_MOLECULE, ProductType.COMBINATION],
    companySize: CompanySize.LARGE,
    badges: ['Global Reach', 'eCTD Experts'],
    verifiedApprovals: 45,
    orphanDesignations: 2,
    hourlyRateStart: 200,
    hourlyRateEnd: 350,
    teamSize: 220,
    foundedYear: 2005,
    isSponsored: false,
    responseTime: '24-48 hours',
    availability: '2 weeks',
    status: 'approved'
  },
  {
    id: '3',
    name: 'NeuroReg Partners',
    tagline: 'Accelerating CNS Drug Development',
    description: 'Boutique firm dedicated to Neurology and Psychiatry. We helped secure 3 Breakthrough Therapy Designations in the last 2 years. Deep expertise in Alzheimer’s and Depression endpoints.',
    logoUrl: 'https://picsum.photos/id/103/200/200',
    regions: [Region.USA, Region.EU],
    therapeuticAreas: [TherapeuticArea.CNS],
    services: [ServiceType.STRATEGY, ServiceType.INTELLIGENCE],
    pathways: [RegulatoryPathway.BREAKTHROUGH, RegulatoryPathway.STD_505_B_1],
    productTypes: [ProductType.SMALL_MOLECULE, ProductType.DIGITAL],
    companySize: CompanySize.BOUTIQUE,
    badges: ['Breakthrough Designation Experts'],
    verifiedApprovals: 8,
    orphanDesignations: 0,
    hourlyRateStart: 400,
    hourlyRateEnd: 600,
    teamSize: 12,
    foundedYear: 2018,
    isSponsored: false,
    responseTime: '48 hours',
    availability: '1 month',
    status: 'approved'
  },
  {
    id: '4',
    name: 'OncoSubmission Pros',
    tagline: 'Fast-Track Oncology Approvals',
    description: 'We specialize in accelerated approval pathways for oncology assets. Our team understands the nuances of Project Orbis and real-time oncology reviews.',
    logoUrl: 'https://picsum.photos/id/104/200/200',
    regions: [Region.USA, Region.EU, Region.CHINA, Region.AUSTRALIA],
    therapeuticAreas: [TherapeuticArea.ONCOLOGY],
    services: [ServiceType.STRATEGY, ServiceType.SUBMISSIONS],
    pathways: [RegulatoryPathway.ACCELERATED, RegulatoryPathway.BLA, RegulatoryPathway.ORPHAN],
    productTypes: [ProductType.BIOLOGIC, ProductType.SMALL_MOLECULE],
    companySize: CompanySize.SMALL,
    badges: ['Oncology Focused', 'Project Orbis'],
    verifiedApprovals: 18,
    orphanDesignations: 5,
    hourlyRateStart: 300,
    hourlyRateEnd: 450,
    teamSize: 30,
    foundedYear: 2015,
    isSponsored: false,
    responseTime: '< 24 hours',
    availability: 'Immediate',
    status: 'approved'
  },
  {
    id: '5',
    name: 'RarePath Consulting',
    tagline: 'Orphan Drugs. Rare Diseases. Real Results.',
    description: 'Navigating the incentives for rare diseases. We have a 100% success rate with Orphan Drug Designation applications.',
    logoUrl: 'https://picsum.photos/id/106/200/200',
    regions: [Region.USA, Region.EU],
    therapeuticAreas: [TherapeuticArea.RARE_DISEASE, TherapeuticArea.GENE_THERAPY],
    services: [ServiceType.STRATEGY],
    pathways: [RegulatoryPathway.ORPHAN, RegulatoryPathway.STD_505_B_2],
    productTypes: [ProductType.SMALL_MOLECULE, ProductType.CELL_GENE],
    companySize: CompanySize.BOUTIQUE,
    badges: ['Orphan Drug Designation', 'Verified Partner'],
    verifiedApprovals: 6,
    orphanDesignations: 25,
    hourlyRateStart: 250,
    hourlyRateEnd: 400,
    teamSize: 8,
    foundedYear: 2020,
    isSponsored: true,
    responseTime: '24 hours',
    availability: 'Immediate',
    status: 'approved'
  },
  {
    id: '6',
    name: 'Biosimilar Access Group',
    tagline: 'Expert 351(k) Biosimilar Submissions',
    description: 'Focused entirely on biosimilars and interchangeability studies. We guide you through the specific analytical similarity requirements for FDA and EMA.',
    logoUrl: 'https://picsum.photos/id/108/200/200',
    regions: [Region.USA, Region.EU, Region.CANADA],
    therapeuticAreas: [TherapeuticArea.IMMUNOLOGY, TherapeuticArea.ONCOLOGY],
    services: [ServiceType.SUBMISSIONS, ServiceType.STRATEGY],
    pathways: [RegulatoryPathway.BIOSIMILAR],
    productTypes: [ProductType.BIOLOGIC],
    companySize: CompanySize.SMALL,
    badges: ['Biosimilar Expert'],
    verifiedApprovals: 5,
    orphanDesignations: 0,
    hourlyRateStart: 280,
    hourlyRateEnd: 400,
    teamSize: 25,
    foundedYear: 2016,
    isSponsored: false,
    responseTime: '48 hours',
    availability: '2 weeks',
    status: 'approved'
  }
];

export const SAMPLE_PROMPTS = [
  "What are the criteria for FDA Orphan Drug Designation?",
  "Compare EMA Prime vs. FDA Breakthrough Therapy.",
  "Draft an initial meeting request letter for the PMDA.",
  "Summarize recent guidance on decentralized clinical trials."
];

export const MOCK_RFQS: RFQ[] = [
    {
        id: 'rfq-101',
        title: 'Orphan Designation Strategy for Rare Oncology Asset',
        description: 'We are a Phase 1 biotech seeking support for FDA ODD application...',
        status: 'open',
        regions: [Region.USA],
        therapeuticArea: TherapeuticArea.ONCOLOGY,
        pathway: RegulatoryPathway.ORPHAN,
        budgetRange: '$50k - $100k',
        postedDate: '2024-10-10',
        proposalCount: 3,
        invitedConsultancyIds: ['5', '1'],
        matchScores: {'5': 95, '1': 88},
        slaMetrics: { timeToFirstView: 2.5, avgResponseTime: 24, responseRate: 100 }
    },
    {
        id: 'rfq-102',
        title: 'eCTD Publishing for Global Phase 3',
        description: 'Need full publishing support for upcoming submissions in US, EU, and Japan.',
        status: 'evaluation',
        regions: [Region.USA, Region.EU, Region.JAPAN],
        therapeuticArea: TherapeuticArea.CARDIOVASCULAR,
        pathway: RegulatoryPathway.STD_505_B_1,
        budgetRange: '$150k - $300k',
        postedDate: '2024-10-05',
        proposalCount: 8,
        slaMetrics: { timeToFirstView: 1.1, avgResponseTime: 18, responseRate: 85 }
    }
];

export const MOCK_PROPOSALS: Proposal[] = [
    {
        id: 'prop-1',
        rfqId: 'rfq-101',
        consultancyId: '5',
        consultancyName: 'RarePath Consulting',
        price: 75000,
        currency: 'USD',
        timelineWeeks: 6,
        status: 'shortlisted',
        submittedDate: '2024-10-12',
        summary: 'Comprehensive strategy + application drafting + FDA liaison.'
    },
    {
        id: 'prop-2',
        rfqId: 'rfq-101',
        consultancyId: '1',
        consultancyName: 'BioReg Global',
        price: 95000,
        currency: 'USD',
        timelineWeeks: 5,
        status: 'pending',
        submittedDate: '2024-10-13',
        summary: 'Expert review by former FDA staff included.'
    }
];

export const MOCK_VERIFICATION_REQUESTS: VerificationRequest[] = [
    {
        id: 'ver-1',
        consultancyId: '1',
        consultancyName: 'BioReg Global Strategies',
        claimType: 'Designation',
        details: 'RMAT Designation for Gene Therapy Product X',
        evidenceFiles: [{id: 'ev1', name: 'FDA_Letter_Redacted.pdf', url: '#', type: 'pdf'}],
        status: 'pending',
        submittedDate: '2024-10-14'
    },
    {
        id: 'ver-2',
        consultancyId: '2',
        consultancyName: 'PharmaLink Solutions',
        claimType: 'Approval',
        details: 'NDA Approval for Cardiovascular Drug Y',
        evidenceFiles: [{id: 'ev2', name: 'Approval_Notice.pdf', url: '#', type: 'pdf'}],
        status: 'approved',
        submittedDate: '2024-10-01'
    }
];

export const MOCK_PENDING_VALIDATIONS: ClientFeedback[] = [
    {
        id: 'fb-1',
        projectId: 'rfq-009',
        consultancyId: '3',
        rating: 0,
        comment: '',
        isVerifiedPurchase: true,
        date: '2024-09-30'
    }
];

export const MOCK_SUBSCRIPTION: Subscription = {
    planId: 'professional',
    status: 'active',
    nextBillingDate: '2024-11-01',
    paymentMethodLast4: '4242',
    features: {
        rfqsRemaining: 999, // Unlimited
        canViewAnalytics: true,
        canExportData: true
    }
};

export const MOCK_INVOICES: Invoice[] = [
    { id: 'inv-1001', date: '2024-10-01', amount: 3500, status: 'paid', pdfUrl: '#' },
    { id: 'inv-0901', date: '2024-09-01', amount: 3500, status: 'paid', pdfUrl: '#' },
];

export const MOCK_ADDONS: AddOn[] = [
    { id: 'add-1', name: 'Market Intelligence Report: Oncology 2024', price: 2500, description: 'Deep dive into regulatory trends.', purchased: false },
    { id: 'add-2', name: 'Competitor Benchmarking Tool', price: 500, description: 'Compare your spend vs market avg.', purchased: true }
];

export const MOCK_CONSULTANCY_ANALYTICS = {
    funnel: [
        { name: 'Profile Views', value: 1200 },
        { name: 'Shortlisted', value: 300 },
        { name: 'RFQs Received', value: 45 },
        { name: 'Wins', value: 12 },
    ],
    peerComparison: [
        { metric: 'Hr Rate ($)', myValue: 450, marketAvg: 380 },
        { metric: 'Response (Hrs)', myValue: 2, marketAvg: 24 },
        { metric: 'Win Rate (%)', myValue: 26, marketAvg: 15 }
    ]
};

export const MOCK_MARKET_TRENDS = [
    { region: 'USA (FDA)', demand: 85 },
    { region: 'EU (EMA)', demand: 65 },
    { region: 'China (NMPA)', demand: 40 },
    { region: 'Japan (PMDA)', demand: 35 }
];

export const MOCK_CLIENT_SPEND_DATA = [
    { category: 'Strategy', spend: 150000, benchmark: 120000 },
    { category: 'Publishing', spend: 45000, benchmark: 50000 },
    { category: 'Writing', spend: 80000, benchmark: 75000 }
];

export const MOCK_NOTIFICATIONS: Notification[] = [
    { id: 'n1', type: 'rfq', title: 'New Proposal Received', message: 'BioReg Global sent a proposal for RFQ-101', date: '2 mins ago', read: false },
    { id: 'n2', type: 'system', title: 'Subscription Renewed', message: 'Your Professional Plan was renewed successfully.', date: '1 day ago', read: true }
];

export const MOCK_THREADS: Thread[] = [
    {
        id: 'rfq-101-t1',
        subject: 'RFQ-101: Orphan Strategy',
        participants: [{id: '1', name: 'BioReg Global'}],
        unreadCount: 1,
        lastMessage: {
            id: 'm1', senderId: '1', senderName: 'BioReg Global', content: 'We have attached the revised timeline.', timestamp: new Date(), read: false
        }
    }
];

export const MOCK_TASKS: Task[] = [
    { id: 't1', title: 'Review Proposal from Apex', dueDate: '2024-10-25', completed: false, priority: 'high' },
    { id: 't2', title: 'Upload NDA Document', dueDate: '2024-10-26', completed: true, priority: 'medium' }
];

export const MOCK_REPORTED_ISSUES: ReportedIssue[] = [
    { id: 'rep-1', targetId: '2', targetName: 'PharmaLink Solutions', reporter: 'Client X', reason: 'Misrepresented eCTD capabilities', status: 'open', date: '2024-10-20', severity: 'medium' },
    { id: 'rep-2', targetId: 'user-55', targetName: 'John Doe', reporter: 'Consultant Y', reason: 'Inappropriate messaging', status: 'resolved', date: '2024-10-15', severity: 'low' }
];

export const MOCK_CONTENT_ITEMS: ContentItem[] = [
    { id: 'c1', title: 'Guide to FDA Accelerated Approval', type: 'guide', status: 'published', views: 1540, lastUpdated: '2024-09-15', author: 'Admin Team' },
    { id: 'c2', title: 'Webinar: EMA Clinical Trials Regulation', type: 'webinar', status: 'draft', views: 0, lastUpdated: '2024-10-21', author: 'Dr. Guest Speaker' }
];

export const MOCK_ALL_USERS: User[] = [
    { id: 'u1', name: 'Dr. Jane Doe', email: 'jane@bioreg.com', role: 'consultant', status: 'active', isOnboardingComplete: true, organization: 'BioReg Global' },
    { id: 'u2', name: 'Mike Biotech', email: 'mike@startuprx.com', role: 'client', status: 'active', isOnboardingComplete: true, organization: 'Startup Rx' },
    { id: 'u3', name: 'Suspended User', email: 'bad@actor.com', role: 'consultant', status: 'suspended', isOnboardingComplete: true, organization: 'Shadow Corp' }
];

export const MOCK_ACTIVITY_LOGS: ActivityLog[] = [
    { id: 'log-1', action: 'Login Successful', user: 'Jane Doe', timestamp: '2024-10-24 09:15:00', ipAddress: '192.168.1.1', details: 'Via Email' },
    { id: 'log-2', action: 'Updated Profile', user: 'Jane Doe', timestamp: '2024-10-23 14:30:00', ipAddress: '192.168.1.1', details: 'Changed hourly rate' },
    { id: 'log-3', action: 'Viewed RFQ-101', user: 'Jane Doe', timestamp: '2024-10-23 10:00:00', ipAddress: '192.168.1.1' },
];

export const MOCK_ORG_SETTINGS: OrgSettings = {
    allowedDomains: ['bioreg.com', 'regulatory.consulting'],
    require2FA: true,
    visibility: 'public',
    defaultNDALink: 'https://example.com/standard-nda.pdf',
    notifications: {
        emailRfqUpdates: true,
        emailMarketing: false,
        emailSecurityAlerts: true
    }
};
